<div class="config-container">
  <div class="details-title">{{ 'callbackDisplay:Configuration' | i18next }}</div>
  <div class="config-wrapper">
    <div class="section">
      <div class="parameters-header">
        <h3>{{ 'callbackDisplay:Callback Display page parameters' | i18next }}</h3>
        <div class="top-buttons">
          <button (click)="onFullscreen()" [matTooltip]="isFullscreen?'Minimise':'Maximise'"
            matTooltipClass="tooltip-font-14">
            <i class="fal" [class]="isFullscreen?'fa-compress':'fa-expand'"></i>
          </button>
          <button (click)="back()" [matTooltip]="'Close' | i18next " matTooltipClass="tooltip-font-14"> <i
              class="fal fa-times-circle"></i></button>
        </div>
      </div>
      <div class="callback-body thin-scroll">
        <div class="section-content ">
          <div><app-textbox [title]="'callbackDisplay:Name' | i18next " [(model)]="configData.name" textboxWidth="100%"
              required (validChange)="checkIsValid($event,'name')" maxlength="50"></app-textbox></div>
          <div><app-textbox [title]="'callbackDisplay:Page name' | i18next" [(model)]="configData.pageName"
              textboxWidth="100%" required (validChange)="checkIsValid($event,'pageName')" maxlength="30"></app-textbox>
          </div>
          <div class="img-input">
            <div>
              <div class="input-title">{{ 'callbackDisplay:Logo' | i18next }}</div>
              <input #logoInput hidden="true" type="file" onclick="this.value=null" (change)="logoInputChange($event)"
                accept="image/png, image/jpeg" />
              <button matButton class="primary-button" (click)="logoInput.click()">{{
                'callbackDisplay:Select company logo' |
                i18next }}</button>
            </div>
            <img *ngIf="logo" [src]="logo" alt="Logo" class="logo" />
          </div>

          <div class="img-input">
            <div>
              <div class="input-title">{{ 'callbackDisplay:Picture' | i18next }}</div>
              <input #pictureInput hidden="true" type="file" onclick="this.value=null"
                (change)="pictureInputChange($event)" accept="image/png, image/jpeg" />
              <button matButton class="primary-button" (click)="pictureInput.click()">{{
                'callbackDisplay:Select footer
                picture' |
                i18next }}</button>
            </div>
            <img *ngIf="picture" [src]="picture" alt="Picture" class="logo" />
          </div>

          <div class="full-width">
            <div class="input-title">{{ 'callbackDisplay:Main Text' | i18next }}</div>
            <textarea name="mainText" #mainText="ngModel" [(ngModel)]="configData.mainText" rows="5"
              class=" thin-scroll" required maxlength="500"></textarea>
          </div>

          <div><app-textbox [title]="'callbackDisplay:Position in queue' | i18next"
              [(model)]="configData.positionInQueue" textboxWidth="100%" required
              (validChange)="checkIsValid($event,'positionInQueue')" maxlength="50"></app-textbox></div>

          <div *ngIf="false"><app-textbox [title]="'callbackDisplay:Estimated wait time' | i18next"
              [(model)]="configData.estimatedWaitTime" textboxWidth="100%" maxlength="30"></app-textbox></div>

          <div><app-textbox [title]="'callbackDisplay:Last updated' | i18next" [(model)]="configData.lastUpdated"
              textboxWidth="100%" required (validChange)="checkIsValid($event,'lastUpdated')"
              maxlength="50"></app-textbox>
          </div>

          <div><app-textbox [title]="'callbackDisplay:Callback number' | i18next" [(model)]="configData.callbackNumber"
              textboxWidth="100%" required (validChange)="checkIsValid($event,'callbackNumber')"
              maxlength="50"></app-textbox></div>

          <div><app-textbox [title]="'callbackDisplay:Cancel' | i18next " [(model)]="configData.cancel"
              textboxWidth="100%" required (validChange)="checkIsValid($event,'cancel')" maxlength="30"></app-textbox>
          </div>
          <div><app-textbox [title]="'callbackDisplay:Are you sure you want to Cancel?' | i18next "
              [(model)]="configData.cancelWarning" textboxWidth="100%" required
              (validChange)="checkIsValid($event,'cancelWarning')" maxlength="50"></app-textbox></div>

          <div><app-textbox [title]="'callbackDisplay:Yes' | i18next" [(model)]="configData.yes" textboxWidth="100%"
              required (validChange)="checkIsValid($event,'yes')" maxlength="15"></app-textbox></div>

          <div><app-textbox [title]="'callbackDisplay:No' | i18next " [(model)]="configData.no" textboxWidth="100%"
              required (validChange)="checkIsValid($event,'no')" maxlength="15"></app-textbox></div>

          <div><app-textbox [title]="'callbackDisplay:Cancel header' | i18next" [(model)]="configData.cancelHeader"
              textboxWidth="100%" required (validChange)="checkIsValid($event,'cancelHeader')"
              maxlength="50"></app-textbox>
          </div>

          <div class="full-width"><app-textbox [title]="'callbackDisplay:Cancel body' | i18next "
              [(model)]="configData.cancelBody" [multiline]="true" [rows]="2" textboxWidth="100%" required
              (validChange)="checkIsValid($event,'cancelBody')" maxlength="200"></app-textbox>
          </div>

          <div><app-textbox [title]="'callbackDisplay:Completed message' | i18next"
              [(model)]="configData.completedMessage" textboxWidth="100%" required
              (validChange)="checkIsValid($event,'completedMessage')" maxlength="200"></app-textbox></div>

          <div *ngIf="false"><app-textbox [title]="'callbackDisplay:Expired message' | i18next"
              [(model)]="configData.expiredMessage" textboxWidth="100%" required
              (validChange)="checkIsValid($event,'expiredMessage')" maxlength="200"></app-textbox></div>
          <div><app-textbox [(model)]="configData.smsFrom" textboxWidth="100%" required pattern="[a-zA-Z0-9\- ]+"
              (validChange)="checkIsValid($event,'smsFrom')" maxlength="11" minlength="2"
              [title]="'callbackDisplay:SMS From/Sender'| i18next"></app-textbox></div>
          <div class="full-width sms-message"><app-textbox [(model)]="configData.smsMessage" textboxWidth="100%"
              required [multiline]="true" [rows]="3" (validChange)="checkIsValid($event,'smsMessage')" maxlength="260"
              [title]="'callbackDisplay:SMS message'| i18next"></app-textbox>
            <span class="sms-message-characters">Characters: {{configData?.smsMessage?.length}}</span>
          </div>
        </div>
      </div>
      <div class="config-footer">
        <div>
        </div>
        <div>
          <button (click)="saveConfig()" matButton class="primary-button"
            [disabled]="!formIsValid || mainText.errors ">{{'Save' | i18next }}</button>
          <button (click)="resetConfig()" matButton class="secondary-button">{{ 'Undo changes' | i18next
            }}</button>
        </div>
      </div>
    </div>
  </div>

</div>